import { Identifiable, List, Project } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedList, Linker } from "../linkers/types";
import { formatDate } from "../utils/formatDate";
import { mapError } from "../utils/mapError";

function saveList(httpClient: HttpClient, linker: Linker) {
  return (
    project: Identifiable<Project>,
    { startDate, endDate, ...list }: List,
  ) =>
    new Promise<Identifiable<List>>((resolve, reject) =>
      httpClient
        .sendHttpRequest<LinkedList>({
          endpoint: `/activities`,
          method: HttpMethods.POST,
          data: {
            ...(list.parentList && {
              activityParent: `/activities/${list.parentList.uuid}`,
            }),
            ...(startDate && { startDate: formatDate(startDate) }),
            ...(endDate && { endDate: formatDate(endDate) }),
            project: `/projects/${project.uuid}`,
            subActivities: list.subLists.map((subList) => ({
              ...subList,
              rank: 0,
            })),
            name: list.name,
            description: list.description,
            ...(list.activityKeyRank !== -1 && {
              activityKeyRank: list.activityKeyRank,
            }),
          },
        })
        .then(linker.linkList)
        .then(resolve)
        .catch((e) =>
          reject(
            mapError(e, {
              emptyName: "emptyName",
              duplicateName: "duplicateName",
              invalidDateRange: "invalidDateRange",
              startDateOutOfBound: "startDateOutOfBound",
              listNotFound: "listNotFound",
            }),
          ),
        ),
    );
}

export { saveList };
